export enum ResponseFormat {
    String = 0,
    Json,
    Number,
    Buffer
}
